export function isPamUser(userData: any): boolean {
  return userData && userData.active && userData.hasOwnProperty('userType') && userData.userType === 'PAM';
}

export function isProfileComplete(userData: any): boolean {
  return userData && userData.active && userData.company && userData.company.profileComplete;
}

export function filterUserRoles(userData: any, roles: string[]): any[] {
  if (!userData || !userData.roles) {
    return [];
  }
  return userData.roles.filter((element: any) => roles.includes(element.name));
}

export function isCompanyBlocked(userData: any): boolean {
  return userData.companyBlocked ||
    (userData.companyEligibleChallengesDTO && userData.companyEligibleChallengesDTO.companyBlocked);
}

export function isEmearUser(userData: any): boolean {
  return userData.company && userData.company.region === 'EMEAR';
}

// EMEAR users are blocked only until this cutoff date; from this date onward they are allowed through.
export function isEmearBlocked(userData: any): boolean {
  if (!isEmearUser(userData)) {
    return false;
  }
  const pstOffsetMillis = 420 * 60 * 1000;
  const nowInPst = Date.now() - pstOffsetMillis;
  const cutoff = new Date('July 14, 2026 23:59:59').getTime();
  return nowInPst < cutoff;
}

export function isOnlyApprover(userData: any): boolean {
  return userData.roles &&
    userData.roles.find((r: any) => r.name === 'AC_APPROVER') &&
    userData.roles.length === 1;
}

export function hasApproverRole(userData: any): boolean {
  return userData.roles && !!userData.roles.find((r: any) => r.name === 'AC_APPROVER');
}

export function hasCiscoAdminRole(userData: any): boolean {
  return userData.roles && !!userData.roles.find((r: any) => r.name === 'CISCO_ADMIN');
}
